import { render } from "./Register.vue?vue&type=template&id=e59c811e"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/lf.m2geo.ie/releases/20261103161156/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Auth/Register.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e59c811e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e59c811e', __exports__)) {
    console.log('reload')
    api.reload('e59c811e', __exports__)
  }
  
  module.hot.accept("./Register.vue?vue&type=template&id=e59c811e", () => {
    console.log('re-render')
    api.rerender('e59c811e', render)
  })

}


export default __exports__